import { createSharedSlice } from '@luna/state';

import type { SnackItem } from './SnackItem';

export const useNotificationsState = createSharedSlice({
    name: 'snackbar/state',
    initialState: {
        items: [] as SnackItem[],
    },
    reducers: {
        addItem(state, action: { payload: SnackItem }) {
            state.items = [...state.items, action.payload];
        },
        removeItem(state, action: { payload: string | number }) {
            state.items = state.items.filter((item) => item.id !== action.payload);
        },
        reset(state) {
            state.items = [];
        },
    },
});
